import CustomButton from './custom-button.vue';
export default CustomButton;
